import { Divider } from "@mui/material"

export default function Header({ children }) {
  return <div className="header">
    {children}
    <Divider />
  </div>
}
